import { Image } from "./Image";
import { modifySVGWithElementProperties } from "../util/illustration";
import { degreesToRadians } from "../util/math";
import { IllustrationElement, PapyrusComponent } from "../types";

export const Illustration: PapyrusComponent<Omit<IllustrationElement, "type">> = (props) => {
    // When caching is enabled we use the provided cached objectURL, this is much faster
    // than traversing and rendering the svg entirely inline.

    if (props.cachedObjectURL && !props._renderingConfiguration?.omitCachedFields) {
        return (
            <Image
                id={props.id}
                src={props.cachedObjectURL}
                x={props.x}
                y={props.y}
                width={props.width}
                height={props.height}
                rotation={props.rotation}
                preserveAspectRatio="none"
                immutable={props.immutable}
                mask={props.stepName ? undefined : props.mask}
            />
        );
    }

    const rotation = props.rotation || 0;
    const angleInRadians = degreesToRadians(rotation);
    const rotC = Math.cos(angleInRadians);
    const rotS = -Math.sin(angleInRadians);

    const transform = `
    matrix(1, 0, 0, 1, ${props.x}, ${props.y})
    matrix(1, 0, 0, 1, ${props.width / 2}, ${props.height / 2})
    matrix(${rotC}, ${-rotS}, ${rotS}, ${rotC}, 0, 0)
    matrix(1, 0, 0, 1, ${-props.width / 2}, ${-props.height / 2})
    `;

    if (!props.svg) {
        throw new Error(
            `Illustration element ${props.id} (stepName ${props.stepName}) lacked svg from src ${props.src} at render time.`,
        );
    }

    return (
        <g mask={props.stepName ? undefined : props.mask}>
            <g
                transform={transform}
                dangerouslySetInnerHTML={{
                    __html: modifySVGWithElementProperties(
                        props.svg,
                        props.width,
                        props.height,
                        props.colors,
                        props._renderingConfiguration?.spotColors,
                    ),
                }}
            />
        </g>
    );
};
